// extracted by mini-css-extract-plugin
module.exports = {"records-info":"j1IVOYSFVEI3Mz_rp8hQJ"};